import React from "react";
import { HelpCircle, FileCheck2, BadgeCheck, ShieldCheck } from "lucide-react";
import { useT } from "@/lib/i18n";
import {
  Tooltip, TooltipContent, TooltipProvider, TooltipTrigger,
} from "@/components/ui/tooltip";

const TIERS = {
  0: { key: "tier0", Icon: HelpCircle, en: "Self-Declared", ta: "சுய அறிவிப்பு",
       desc: "The organisation entered this themselves. We haven't checked it yet." },
  1: { key: "tier1", Icon: FileCheck2, en: "Document-on-File", ta: "ஆவணம் சரிபார்க்கப்பட்டது",
       desc: "Certificates uploaded and read by our team. The papers exist and match." },
  2: { key: "tier2", Icon: BadgeCheck, en: "Registry-Matched", ta: "பதிவேடு பொருந்தியது",
       desc: "Registration numbers cross-checked against DARPAN / MCA / IT registries." },
  3: { key: "tier3", Icon: ShieldCheck, en: "Field-Verified", ta: "நேரில் சரிபார்க்கப்பட்டது",
       desc: "Someone from our team visited the site. Visit date and photos on record." },
};

const CLS = {
  tier0: "bg-tier0-bg border-tier0-border text-tier0-text",
  tier1: "bg-tier1-bg border-tier1-border text-tier1-text",
  tier2: "bg-tier2-bg border-tier2-border text-tier2-text",
  tier3: "bg-tier3-bg border-tier3-border text-tier3-text",
};
const ICON_CLS = {
  tier0: "text-tier0-icon", tier1: "text-tier1-icon", tier2: "text-tier2-icon", tier3: "text-tier3-icon",
};

export function VerificationBadge({ tier = 0, size = "sm" }) {
  const { lang } = useT();
  const meta = TIERS[tier] || TIERS[0];
  const { Icon } = meta;
  const pad = size === "lg" ? "px-3 py-1.5 text-sm" : "px-2.5 py-1 text-xs";
  const iconSize = size === "lg" ? 16 : 13;
  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            data-testid="verification-tier-badge"
            className={`inline-flex items-center gap-1.5 rounded-full border font-semibold ${pad} ${CLS[meta.key]} cursor-help`}
          >
            <Icon size={iconSize} className={ICON_CLS[meta.key]} strokeWidth={2.4} />
            <span>{lang === "ta" ? meta.ta : meta.en}</span>
          </span>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-[240px]">
          <p className="font-semibold mb-0.5">Tier {tier}: {meta.en}</p>
          <p className="text-xs opacity-90">{meta.desc}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

export default VerificationBadge;
